import { render, staticRenderFns } from "./AuthHeader.vue?vue&type=template&id=e4ecca5a&"
import script from "./AuthHeader.vue?vue&type=script&lang=ts&"
export * from "./AuthHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AuthHeader.vue?vue&type=style&index=0&id=e4ecca5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileAvatar: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/profile/ProfileAvatar.vue').default,HomepageUserHeaderBox: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/homepage/HomepageUserHeaderBox.vue').default})
